import { getDistance } from 'geolib';
import { aprsParser } from 'js-aprs-fap'
import { format, addYears } from 'date-fns'
import { xHexToString, fToC } from './tmlf.js'

const API_URL = 'https://aprsdb.tomul.net:45443/json/packets.php?output=hex&callsign='
const API_TEMPBAR_URL = 'https://aprsdb.tomul.net:45443/json/wx-tempbar.php?b=0&ya=1&sort=DESC&call='

function getClearData() {
  let data = {
    array: [],
    dataType: {
      isLocation: false,
      isPackets: false,
      isWx: false,
      isAltitude: false,
    },
    totalDistance: 0,
  }
  return data
}

async function getRawPackets(call, date, days) {

  let data = getClearData()

  if (!days) {days = '0'}

  if (call && date) {

    let parser = new aprsParser()

    try {
      let url = `${API_URL}${call.toUpperCase()}&od=${date}&days=${days}`
      // console.log(url)
      await (await fetch(url)).json().then(result => {
        if (result) {
          let altitudeRecCount = 0
          for (let item in result) {
            let parsedPacket = parser.parseaprs(xHexToString(result[item].packet))
            parsedPacket.receivedTime = result[item].reporttime
            if (parsedPacket.type == 'location') { data.dataType.isLocation = true }
            if (parsedPacket.wx) { 
              data.dataType.isWx = true
              if (parsedPacket.wx.wind_speed) {
                  parsedPacket.wx.wind_speed = mps2kph(parsedPacket.wx.wind_speed)
              }
              if (parsedPacket.wx.wind_gust) {
                parsedPacket.wx.wind_gust = mps2kph(parsedPacket.wx.wind_gust)
            }
            }
            if (parsedPacket.altitude) { altitudeRecCount = altitudeRecCount + 1 }
            data.array.push(parsedPacket)
          }
          let calculateDistancesResult = calculateDistances(data.array)
          data.array = calculateDistancesResult.data
          data.totalDistance = calculateDistancesResult.totalDistance
          if ((altitudeRecCount >= 5) && (data.totalDistance)) {
            data.dataType.isAltitude = true 
            } else { 
              data.dataType.isAltitude = false 
            }
          if (data.array.length) { data.dataType.isPackets = true }                   
        }
      })
    } catch (error) {
      console.log(error)
      // data.array = []
    }

  }
  

  return data

}

async function getWxTempBar(call, date, days) {

  let data = []

  let okres = 24
  if (days) {
    okres = days * 24
  }

  if (!days) {days = '0'}

  if (call && date) {

    try {
      let url = `${API_TEMPBAR_URL}${call.toUpperCase()}&od=${date}&okres=${okres}`
      // console.log(url)
      await (await fetch(url)).json().then(result => {
        if (result) {       
          for (let item in result) {
            let date = new Date(result[item].reporttime);
            let dateAddYear = format(addYears(date,1),'yyyy-MM-dd HH:mm:ss.SSS')
            data.push({x: dateAddYear, y: fToC(result[item].temperature)})
           }                
        }
      })
    } catch (error) {
      console.log(error)
      // data.array = []
    }
    
  }
  

  return data

}

  function calculateDistances(resultData) {
    let totalDistance = 0
    if (resultData) {
      const startPos = { latitude: null, longitude: null }
      const endPos = { latitude: null, longitude: null }
      let distance = 0
      for (var i = resultData.length - 1; i >= 0; i--) {
        endPos.latitude = resultData[i].latitude
        endPos.longitude = resultData[i].longitude
        if (startPos.latitude && startPos.longitude) {
          try {
            distance = getDistance(startPos, endPos)
            totalDistance = totalDistance + distance
          } catch (error) {
            distance = undefined
            // console.log(error)
          }
        }
        startPos.latitude = endPos.latitude
        startPos.longitude = endPos.longitude
        resultData[i].distance = distance
      }
    }
    return {data: resultData, totalDistance: totalDistance}
  }


  function mps2kph(v) {
    if (v) {
      v = (v*3600/1000).toFixed(1)
    }
    return v
  }

  export {getRawPackets, getWxTempBar, getClearData}
